export class Settings {
    Enabled: boolean;
    Name: string;
}
